import { Link, useLocation, useNavigate } from "react-router-dom";
import { Inbox, FileText, LogOut, ExternalLink } from "lucide-react";
import { LogoMark } from "@/components/site/Logo";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { to: "/admin/leads", label: "Leads", icon: Inbox },
  { to: "/admin/blog", label: "Resources", icon: FileText },
];

const AdminLayout = ({ children }) => {
  const { logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const doLogout = async () => {
    await logout();
    navigate("/admin");
  };

  return (
    <div className="min-h-screen bg-sand2 flex">
      <aside className="w-64 shrink-0 bg-forest text-sand flex-col justify-between hidden md:flex fixed inset-y-0">
        <div>
          <div className="p-6 flex items-center gap-2.5 border-b border-sand/10">
            <span className="grid place-items-center w-9 h-9 rounded-full bg-sand text-forest"><LogoMark className="w-5 h-5" /></span>
            <span className="font-serif text-lg leading-tight">New Beginnings<br /><span className="text-[10px] uppercase tracking-[0.2em] text-sage">Admin</span></span>
          </div>
          <nav className="p-4 space-y-1">
            {NAV.map((n) => {
              const Icon = n.icon;
              const active = location.pathname === n.to;
              return (
                <Link key={n.to} to={n.to} data-testid={`admin-nav-${n.label.toLowerCase()}`} className={`flex items-center gap-3 px-4 py-3 rounded-xl transition-colors ${active ? "bg-sand text-forest font-semibold" : "text-sand/80 hover:bg-forestdark"}`}>
                  <Icon className="w-5 h-5" /> {n.label}
                </Link>
              );
            })}
          </nav>
        </div>
        <div className="p-4 space-y-1 border-t border-sand/10">
          <a href="/" target="_blank" rel="noreferrer" className="flex items-center gap-3 px-4 py-3 rounded-xl text-sand/80 hover:bg-forestdark transition-colors">
            <ExternalLink className="w-5 h-5" /> View site
          </a>
          <button onClick={doLogout} data-testid="admin-logout" className="w-full flex items-center gap-3 px-4 py-3 rounded-xl text-sand/80 hover:bg-forestdark transition-colors">
            <LogOut className="w-5 h-5" /> Sign out
          </button>
        </div>
      </aside>

      <main className="flex-1 md:ml-64">
        {/* Mobile top bar */}
        <div className="md:hidden flex items-center justify-between bg-forest text-sand px-5 py-4">
          <span className="font-serif text-lg">NB Admin</span>
          <div className="flex gap-4">
            {NAV.map((n) => <Link key={n.to} to={n.to} className="text-sm">{n.label}</Link>)}
            <button onClick={doLogout} className="text-sm">Exit</button>
          </div>
        </div>
        <div className="p-5 md:p-10">{children}</div>
      </main>
    </div>
  );
};

export default AdminLayout;
